import React, { useState, useCallback, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import OTPPopup from "../../components/appoinment-detail/OTPPopup";
import { calculateDuration } from "../../utility/calculateDuration";
import { useApi } from "../../components/context/apiContext";
import Notification from "../../utility/Notification";
import { formatDate, removeAmPm } from "../../utility/formatDate";
import axiosInstance from "../../utility/axiosInstance";
import { formatTime } from "../../utility/formatDate";
import { getDoctorImageSrc } from "../../utility/getDoctorImageSrc";
import { FaChevronRight } from "react-icons/fa";
import {
  FiChevronDown,
  FiUser,
  FiShield,
  FiAlertCircle,
  FiUsers,
  FiGlobe,
  FiMonitor,
  FiCalendar,
  FiMapPin,
  FiMail,
  FiLoader,
  FiCreditCard,
} from "react-icons/fi";

const AppoinmentBook = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingRegno, setPendingRegno] = useState(""); // REGNO chosen from mobile dropdown
  const [otpPurpose, setOtpPurpose] = useState(""); // "mobile" | "mrno"
  const [pendingMrData, setPendingMrData] = useState(null); // holds API response until OTP passes

  const { addNotification, removeNotification, notifications } = useApi();
  const {
    doctorInfo,
    selectedDoctorId,
    selectedDoctorImage,
    selectedDoctorAbout,
    selectedSpecialty,
    appDate,
    startTime,
    endTime,
  } = location.state || {};
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const [formData, setFormData] = useState({
    startTime: "",
    isRegistered: "No",
    nameInitial: "",
    patientName: "",
    age: "",
    maritalStatus: "",
    gender: "",
    relation: "",
    relativeName: "",
    mobileNumber: "",
    address: "",
    pincode: "",
    city: "",
    duration: "",
    remarks: "",
    endTime: "",
    doctorName: "",
    email: "",
    consultationType: "In-Hospital",
    registrationFee: "",
    consultationFee: "",
    sourceType: "",
    mrNo: "",
    mobileNoSearch: "",
    department: "",
    price: "",
    appointmentDate: "",
    doctorId: "",
    specialityId: "",
    RegFee: "",
  });

  const [appoinmentId, setAppoinmentId] = useState("");
  const [errors, setErrors] = useState({
    patientName: "",
    mobileNumber: "",
    email: "",
  });
  const [showRegisteredFields, setShowRegisteredFields] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchError, setSearchError] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showOTPPopup, setShowOTPPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const isDev = process.env.REACT_APP_PHASE === "development";

  const [otp, setOtp] = useState("");

  const validateForm = () => {
    let valid = true;

    const newErrors = {
      patientName: "",
      mobileNumber: "",
      email: "",
      age: "",
      gender: "",
      address: "",
      remarks: "",
      relativeName: "",
    };

    // Name validation
    if (!formData.patientName) {
      newErrors.patientName = "Name is required";
      valid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(formData.patientName.trim())) {
      newErrors.patientName = "Name must contain only letters and spaces";
      valid = false;
    } else if (formData.patientName.trim().length < 2) {
      newErrors.patientName = "Name must be at least 2 characters";
      valid = false;
    } else if (formData.patientName.trim().length > 50) {
      newErrors.patientName = "Name must not exceed 50 characters";
      valid = false;
    }

    if (!formData.age) {
      newErrors.age = "Age is required";
      valid = false;
    }

    if (!formData.gender) {
      newErrors.gender = "Gender is required";
      valid = false;
    }

    if (!formData.address) {
      newErrors.address = "Address is required";
      valid = false;
    }

    // if (!formData.remarks) {
    //   newErrors.remarks = "Remarks is required";
    //   valid = false;
    // }

    // Mobile number validation
    if (!formData.mobileNumber) {
      newErrors.mobileNumber = "Mobile number is required";
      valid = false;
    } else if (!/^\d{10}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Please enter a valid 10-digit mobile number";
      valid = false;
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
      valid = false;
    }

    // Conditional validation for relativeName
    // if (formData.isRegistered === "Yes" && !formData.relativeName) {
    //   newErrors.relativeName = "Relative name is required";
    //   valid = false;
    // }

    setErrors(newErrors);
    return valid;
  };

  useEffect(() => {
    const price = doctorInfo?.DOCTORFEES;
    const doctorName = doctorInfo?.name;
    const department = doctorInfo?.specialization;
    const appointmentDate = appDate;
    const doctorId = selectedDoctorId;
    const specialityId = selectedSpecialty;
    const RegFee = doctorInfo?.REGFESS;

    if (
      doctorName ||
      startTime ||
      department ||
      price ||
      endTime ||
      appointmentDate
    ) {
      setFormData((prevData) => {
        let duration = prevData.duration;
        if (startTime && endTime) {
          duration = calculateDuration(
            decodeURIComponent(startTime),
            decodeURIComponent(endTime),
          );
        }
        return {
          ...prevData,
          doctorName: doctorName
            ? decodeURIComponent(doctorName)
            : prevData.doctorName,
          startTime: startTime
            ? decodeURIComponent(startTime)
            : prevData.startTime,
          department: department
            ? decodeURIComponent(department)
            : prevData.department,
          price: price ? decodeURIComponent(price) : prevData.price,
          appointmentDate: appointmentDate
            ? decodeURIComponent(appointmentDate)
            : prevData.appointmentDate,
          endTime: endTime ? decodeURIComponent(endTime) : prevData.endTime,
          doctorId: doctorId ? decodeURIComponent(doctorId) : prevData.doctorId,
          RegFee: doctorId ? decodeURIComponent(RegFee) : prevData.RegFee,
          specialityId: specialityId
            ? decodeURIComponent(specialityId)
            : prevData.specialityId,
          duration: duration,
        };
      });
    }
  }, [
    doctorInfo,
    selectedDoctorId,
    selectedSpecialty,
    appDate,
    startTime,
    endTime,
  ]);

  useEffect(() => {
    const intervalId = setInterval(
      async () => {
        try {
          await axios.get(
            "https://bookingengine.asianheartinstitute.org/public/api/appointments/cancel-expired",
          );
          console.log("Expired slots cancel API called");
        } catch (error) {
          console.error("Error calling cancel-expired API:", error);
        }
      },
      2 * 60 * 1000,
    );

    // Optional: Clear interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        inputRef.current &&
        !inputRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "isRegistered") {
      setShowRegisteredFields(value === "Yes");
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendOtpToPhone = useCallback(async (phone) => {
    try {
      const generatedOtp = Math.floor(1000 + Math.random() * 9000).toString();
      setOtp(generatedOtp);

      const fd = new FormData();
      fd.append("otp", generatedOtp);
      fd.append("phone", phone);

      await axios.post("https://asianheartinstitute.org/sms/otp.php", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      addNotification("OTP sent successfully", "success");
      setShowOTPPopup(true);
      return true;
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        (err.request ? "No response from server" : "Failed to send OTP");
      addNotification(msg, "error");
      return false;
    }
  }, []);

  // Debounce function
  const debounce = (func, delay) => {
    return (...args) => {
      if (searchTimeout) clearTimeout(searchTimeout);
      const newTimeout = setTimeout(() => {
        func(...args);
      }, delay);
      setSearchTimeout(newTimeout);
    };
  };

  // Auto-fill form with patient data
  const autoFillForm = useCallback((patientData) => {
    setFormData((prev) => ({
      ...prev,
      patientName: patientData.PATIENT_NAME || "",
      mrNo: patientData.REGNO || "",
      mobileNumber: patientData.PHONE || "",
      // mobileNoSearch: patientData.PHONE || "",
      gender:
        patientData.GENDER === "FeMale" ? "Female" : patientData.GENDER || "",
      address: patientData.ADDRESS || "",
      age: patientData.AGE || "",
      email: patientData.EMAIL || "",
      isRegistered: "Yes",
    }));
  }, []);

  // Check registration by MRNO
  const checkByMRNO = useCallback(
    async (mrNo) => {
      if (!mrNo || mrNo.length < 3) {
        setSearchError("");
        return;
      }

      setIsSearching(true);
      setSearchError("");

      try {
        const response = await axiosInstance.post(
          isDev
            ? "/TApiQuery?webformid=wf3361&terminalid=1%2083.82.126.219"
            : `/TApiQuery?webformid=wf3356&terminalid=${process.env.REACT_APP_TERMINAL_ID}`,
          `data=[{"REGNO":"${mrNo}"}]`,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } },
        );

        if (response.data?.length > 0) {
          const patient = response.data[0];

          // ── PHONE is empty → cannot send OTP → block ──────────────────────
          if (!patient.PHONE || patient.PHONE.trim() === "") {
            setSearchError(
              "No phone number registered for this MR. Please contact reception.",
            );
            setPendingMrData(null);
            return;
          }

          // ── PHONE exists → store data and send OTP ────────────────────────
          setPendingMrData(patient); // hold data — do NOT autoFill yet
          setOtpPurpose("mrno");
          await sendOtpToPhone(patient.PHONE.trim());
        } else {
          setSearchError("No patient found with this MR number");
          setPendingMrData(null);
        }
      } catch {
        setSearchError("Error checking registration");
        setPendingMrData(null);
      } finally {
        setIsSearching(false);
      }
    },
    [autoFillForm, sendOtpToPhone],
  );

  // Check registration by mobile number

  const checkByMobile = useCallback(async (mobileNo) => {
    if (!mobileNo || mobileNo.length < 5) {
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    if (mobileNo.length < 10) {
      setSearchError("Please enter a valid 10-digit mobile number");
      setSearchResults([]);
      setShowDropdown(false);
      return;
    }

    setIsSearching(true);
    setSearchError("");

    try {
      const response = await axiosInstance.post(
        isDev
          ? "/TApiQuery?webformid=wf3362&terminalid=1%2083.82.126.219"
          : `/TApiQuery?webformid=wf3357&terminalid=${process.env.REACT_APP_TERMINAL_ID}`,
        `data=[{"MOBILENO":"${mobileNo}"}]`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      if (response.data && response.data.length > 0) {
        setSearchResults(response.data);
        setShowDropdown(true);
      } else {
        setSearchResults([]);
        setShowDropdown(false);
        setSearchError("No patient found with this mobile number");
      }
    } catch (error) {
      console.error("Error checking by mobile:", error);
      setSearchError("Error checking registration");
      setSearchResults([]);
      setShowDropdown(false);
    } finally {
      setIsSearching(false);
    }
  }, []);

  const handleSelectPatient = useCallback(
    async (regno) => {
      setShowDropdown(false);

      // Find the phone number from search results for this REGNO
      const patient = searchResults.find((p) => p.REGNO === regno);
      if (!patient) return;

      setPendingRegno(regno);
      setOtpPurpose("mobile");

      await sendOtpToPhone(patient.PHONE || formData.mobileNoSearch);
    },
    [searchResults, formData.mobileNoSearch, sendOtpToPhone],
  );

  // Debounced versions of search functions
  const debouncedCheckByMRNO = useCallback(debounce(checkByMRNO, 500), [
    checkByMRNO,
  ]);

  const debouncedCheckByMobile = useCallback(debounce(checkByMobile, 500), [
    checkByMobile,
  ]);

  // Handle MRNO field changes
  const handleMRNOChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, mrNo: value }));
    setSearchError("");
    setPendingMrData(null);
    debouncedCheckByMRNO(value); // debounced, safe
  };

  // Handle mobile search field changes
  const handleMobileSearchChange = (e) => {
    // const value = e.target.value;
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setFormData((prev) => ({ ...prev, mobileNoSearch: value }));
    setShowDropdown(false);
    setSearchResults([]);
    const patientData = {
      PATIENT_NAME: "",
      REGNO: "",
      PHONE: "",
      GENDER: "",
      ADDRESS: "",
      AGE: "",
      EMAIL: "",
    };
    autoFillForm(patientData);
    if (value.length === 10) {
      debouncedCheckByMobile(value);
    }
  };

  // Clean up timeouts on unmount
  useEffect(() => {
    return () => {
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, [searchTimeout]);

  const sendOtp = async () => {
    try {
      const generatedOtp = Math.floor(1000 + Math.random() * 9000);
      setOtp(generatedOtp.toString());

      // Create FormData object with a different variable name
      const requestFormData = new FormData();
      requestFormData.append("otp", generatedOtp);
      requestFormData.append("phone", formData.mobileNumber);

      const response = await axios.post(
        "https://asianheartinstitute.org/sms/otp.php",
        requestFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      addNotification("OTP Sent Succesfully", "success");
      setShowOTPPopup(true);
    } catch (error) {
      let errorMessage = "An error occurred while sending OTP.";
      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          `Server responded with status ${error.response.status}`;
      } else if (error.request) {
        errorMessage =
          "No response received from server. Please check your connection.";
      }

      addNotification(errorMessage, "success");
      return false;
    }
  };

  const sendBookingSMS = async () => {
    try {
      const requestFormData = new FormData();
      requestFormData.append("phone", formData.mobileNumber);
      requestFormData.append("name", formData.patientName);
      requestFormData.append("appointment_date", formData?.appointmentDate);
      requestFormData.append("doctor_name", formData.doctorName);
      requestFormData.append("appointment_time", formData.startTime);
      // console.log("FormData phone:", requestFormData.get("phone"));

      const response = await axios.post(
        "https://asianheartinstitute.org/sms/bookingConfirm.php",
        requestFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      // alert("Booking Confirm Succesfully");
    } catch (error) {
      console.error("Error sending OTP:", error);
      let errorMessage = "An error occurred while sending OTP.";
      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          `Server responded with status ${error.response.status}`;
      } else if (error.request) {
        errorMessage =
          "No response received from server. Please check your connection.";
      }

      alert(errorMessage);
      return false;
    }
  };

  const chekslotagain = async () => {
    try {
      const datatosend = {
        doctor_id: formData?.doctorId,
        appointment_date: formatDate(formData?.appointmentDate),
        appointment_time: formData?.startTime,
      };

      const response = await axios.post(
        "https://bookingengine.asianheartinstitute.org/public/api/appointments/initiate",
        datatosend,
      );
      if (response?.data?.success === true) {
        setAppoinmentId(response?.data?.appointment_id);

        return true;
      } else {
        addNotification("This slot is already booked");
        navigate(-1);
        return false;
      }
    } catch (error) {
      const errorMsg = error?.response?.data?.message || error.message;
      const rawError = error?.response?.data?.error;

      if (
        errorMsg.includes("Duplicate entry") ||
        rawError?.includes("Duplicate entry") ||
        errorMsg === "This slot has just been taken. Please try another."
      ) {
        addNotification(
          "This slot is reserved. Please try again after a 2 minutes.",
        );
        navigate(-1);
      } else {
        addNotification("Error while checking the slot. Please try again.");
      }

      return false;
    }
  };

  const bookingagain = async (appointmentId, paymentid) => {
    try {
      const datatosend = {
        // The confirmation endpoint expects the id returned by the initiate API.
        // Keep appointmentId as a fallback in case the state update has not landed yet.
        appointment_id: appoinmentId || appointmentId,
        payment_id: paymentid,
      };

      const response = await axios.post(
        "https://bookingengine.asianheartinstitute.org/public/api/appointments/confirm",
        datatosend,
      );

      const rrn =
        response?.data?.rrn_number ??
        response?.data?.data?.rrn_number ??
        response?.data?.rrn ??
        response?.data?.RRN ??
        response?.data?.data?.rrn ??
        response?.data?.data?.RRN;

      if (!rrn) {
        throw new Error("RRN was not returned by the booking confirmation API");
      }

      return rrn;
    } catch (error) {
      console.error("Error confirming booking:", error);
      throw error;
    }
  };

  // check availablity slot
  const checkSlotAvailability = async () => {
    const start = removeAmPm(formData?.startTime);
    const end = removeAmPm(formData?.endTime);

    try {
      const response = await axiosInstance.post(
        isDev
          ? "/TApiQuery?webformid=wf3360&terminalid=1%2083.82.126.219"
          : `/TApiQuery?webformid=wf3358&terminalid=${process.env.REACT_APP_TERMINAL_ID}`,
        {
          data: JSON.stringify([
            {
              DOCTORID: formData?.doctorId,
              FROMDTS: formatDate(formData?.appointmentDate),
              FROMTM: start,
              TOTM: end,
            },
          ]),
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      if (response.data?.[0]?.SLOTDTLS === "true") {
        const success = await chekslotagain();
        return success;
      } else {
        addNotification("This slot is already booked");
        navigate(-1);
        return false;
      }
    } catch (error) {
      alert("Error checking slot availability");
      console.error("Error checking slot:", error);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true); // Start loader

      const isSlotAvailable = await checkSlotAvailability();
      if (!isSlotAvailable) return;

      const otpSentSuccessfully = await sendOtp();
      if (!otpSentSuccessfully) return;
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    } finally {
      setLoading(false); // Stop loader in all cases
    }
  };

  const now = new Date();
  const currentTime = `${now.getHours().toString().padStart(2, "0")}:${now
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  const postAppointmentData = async (paymentResponse, uniqueRef, rrnNumber) => {
    try {
      const apiData = [
        {
          ADDRESS: formData?.address,
          AGE: formData?.age,
          APPPURPOSE: "Follow-up Consultation",
          APPTGIVENDT1: new Date().toISOString().split("T")[0],
          APPTGIVENTM1: currentTime,
          APPTNO: uniqueRef,
          APPTSOURCETYPE: formData.sourceType || "MobileApp",
          CMBHSP: "",
          COLUMID: "",
          DOB: "",
          DOCTORNM: formData.doctorName,
          DURATION: formData.duration,
          EMAIL: formData.email,
          FROMTIME: formData.startTime,
          GENDERTYPE: formData.gender,
          MARITALSTATUS: formData.maritalStatus,
          MRNO: formData.mrNo,
          NAME: formData.patientName,
          PHONE: formData.mobileNumber,
          REFERENCENO: uniqueRef,
          REGID: "",
          RELATIVENM: formData.relativeName,
          AMOUNT: showRegisteredFields
            ? formData.price
            : parseInt(formData?.price) + parseInt(formData?.RegFee),
          PAIDAMT: showRegisteredFields
            ? formData.price
            : parseInt(formData?.price) + parseInt(formData?.RegFee),
          UTRNO: paymentResponse.razorpay_payment_id,
          REFNO: paymentResponse.razorpay_payment_id,
          BANKRRN: rrnNumber,
          OTDate: formatDate(formData?.appointmentDate),
          otFRomtm: removeAmPm(formData?.startTime),
          otTotime: removeAmPm(formData?.endTime),
          docid: formData?.doctorId,
          specdocid: formData?.specialityId,
        },
      ];

      // ⭐ REPLACED FETCH WITH AXIOS INSTANCE ⭐
      const response = await axiosInstance.post(
        isDev
          ? "/TApiQuery?webformid=wf3363&terminalid=183.82.126.219"
          : `/TApiQuery?webformid=wf3359&terminalid=${process.env.REACT_APP_TERMINAL_ID}`,
        `data=${encodeURIComponent(JSON.stringify(apiData))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        },
      );

      const appointmentResponse = response.data;

      if (
        Array.isArray(appointmentResponse) &&
        appointmentResponse[0]?.MSG === "success"
      ) {
        navigate("/thank-you", {
          replace: true,
          state: {
            appointmentData: apiData[0],
            paymentResponse,
            formData,
            selectedDoctorImage,
          },
        });
      } else {
        console.error("Appointment creation failed:", appointmentResponse);
        addNotification("Failed to create appointment. Please try again.");
        throw new Error("Appointment creation failed");
      }

      try {
        await sendBookingSMS();
      } catch (smsError) {
        console.error("Failed to send booking SMS:", smsError);
        // You might want to handle this differently - maybe return the appointment
        // response anyway since the main operation succeeded
      }

      return appointmentResponse;
    } catch (error) {
      console.error("Error in postAppointmentData:", error);
      throw error;
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (document.getElementById("razorpay-script")) {
        resolve(true);
        return;
      }
      const script = document.createElement("script");
      script.id = "razorpay-script";
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async () => {
    const res = await loadRazorpayScript();

    if (!res) {
      addNotification("Failed to load Razorpay SDK. Are you online?");
      return;
    }

    const options = {
      // key: "rzp_test_gOixcmVF4r9Ar3",
      key: isDev ? "rzp_test_gOixcmVF4r9Ar3" : "rzp_live_ThnMzrts4FhaU1",
      amount: showRegisteredFields
        ? formData?.price * 100
        : (parseInt(formData?.price) + parseInt(formData?.RegFee)) * 100,
      // amount: 1 * 100,
      currency: "INR",
      name: "Asian Heart Institute",
      description: "Service Payment",

      // ✅ Success Handler
      handler: async function (response) {
        try {
          const now = new Date();
          const yearShort = now.getFullYear().toString().slice(-2);
          const timePortion = now.getTime().toString().slice(-5);
          const randomDigit = Math.floor(Math.random() * 10);
          const uniqueRef = `${yearShort}${timePortion}${randomDigit}`;

          const rrn = await bookingagain(
            uniqueRef,
            response.razorpay_payment_id,
          );

          console.log("Booking confirmed with RRN:", rrn);

          await postAppointmentData(response, uniqueRef, rrn);
          addNotification(
            `Payment successful! ID: ${response.razorpay_payment_id}`,
            "success",
          );
        } catch (error) {
          addNotification(
            `Payment succeeded but failed to save data. Contact support with Payment ID: ${response.razorpay_payment_id}`,
          );
        }
      },

      prefill: {
        name: formData.patientName || "John Doe",
        email: formData.email || "john@example.com",
        contact: formData.mobileNumber || "9876543210",
      },

      theme: {
        color: "#00ADED",
      },

      // ❌ Modal Closed Handler
      modal: {
        ondismiss: function () {
          addNotification("Payment popup closed. Payment was not completed.");
        },
      },
    };

    // Create Razorpay instance
    const paymentObject = new window.Razorpay(options);

    // ❌ Failure Handler
    paymentObject.on("payment.failed", function (response) {
      const { error } = response;
      console.error("Payment Failed:", error);
      addNotification(
        `Payment failed! Reason: ${error.description} (Code: ${error.code})`,
      );
    });

    // Open the Razorpay modal
    paymentObject.open();
  };

  // const handleVerifyOTP = (otpw) => {
  //   setTimeout(() => {
  //     if (otpw === otp) {
  //       setShowOTPPopup(false);
  //       addNotification("OTP Verify Succesfully!", "success");
  //       handlePayment();
  //     } else {
  //       addNotification(
  //         "Invalid OTP. Please check the code and try again.",
  //         "error",
  //       );
  //     }
  //   }, 500);
  // };

  const handleVerifyOTP = useCallback(
    (enteredOtp) => {
      setTimeout(() => {
        if (enteredOtp !== otp) {
          addNotification("Invalid OTP. Please try again.", "error");
          return;
        }

        setShowOTPPopup(false);
        addNotification("OTP verified successfully!", "success");

        if (otpPurpose === "mobile" && pendingRegno) {
          checkByMRNO(pendingRegno);
          setPendingRegno("");
        } else if (otpPurpose === "mrno" && pendingMrData) {
          autoFillForm(pendingMrData);
          setPendingMrData(null);
        } else {
          handlePayment();
        }

        setOtpPurpose("");
      }, 500);
    },
    [otp, otpPurpose, pendingRegno, pendingMrData, autoFillForm],
  );

  const handleInputFocus = () => {
    if (searchResults.length > 0 && formData.mobileNoSearch) {
      setShowDropdown(true);
    }
  };

  return (
    <>
      {/* <section id="home-search-section">
        <div className="midbox-inner wiki-mk">
          <h2>Schedule Your Appointment Online</h2>
        </div>
      </section> */}

      <section
        id="header-section"
        className="bg-white border-b border-gray-200 shadow-sm relative overflow-hidden flex items-center justify-center pt-0 pb-10 md:pt-22 md:pb-15"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <h1
            className="text-2xl sm:text-4xl font-extrabold text-gray-800 tracking-tight"
            //   style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.1)" }}
          >
            Schedule Your Appointment Online
          </h1>
        </div>
        {/* An overlay can be added here if the text needs more contrast against the image */}
        {/* <div className="absolute inset-0 bg-white opacity-20"></div> */}
      </section>

      <section className="appointment-details-section">
        <div className="app-wiki">
          <div className="app-details-section">
            <div>
              <span
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 text-sm font-medium text-teal-600 rounded-md cursor-pointer transition-all duration-200 group"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 12H5M12 19l-7-7 7-7" />
                </svg>
                Go Back
              </span>
            </div>
            <div className="book-boxapp">
              <h2 className="book-boxpro-text">Appointment Details</h2>

              <div className="bookbox-text">
                <img src="/form8.png" alt="" /> {formData?.department}
              </div>

              <div className="bookbox-text">
                <img src="/form6.png" alt="" /> {formatTime(formData.startTime)}{" "}
                -{formatTime(formData.endTime)}
              </div>

              <div className="bookbox-text">
                <img src="/book-icon4.png" alt="" /> ₹ {formData?.price}
              </div>

              {/* Doctor Info */}
              <div className="dr-img-doc">
                <div className="dr-boximg">
                  <img
                    src={getDoctorImageSrc(selectedDoctorImage)}
                    onError={(e) => {
                      e.currentTarget.src = "/doctor-dummy.png";
                    }}
                    className="w-full h-full object-cover"
                    alt={`${formData?.doctorName}-image`}
                  />
                </div>

                <div className="dr-boxpro">
                  <div className="text-truncate">
                    Dr. {formData?.doctorName}
                  </div>
                  <div className="text-department">{formData?.department}</div>
                </div>
              </div>
              {selectedDoctorAbout && (
                <div className="mt-4 rounded-lg border border-blue-100 bg-white/70 px-4 py-3">
                  <h4
                    className="mb-2 text-sm  text-slate-900"
                    style={{ color: "#0095da" }}
                  >
                    About Doctor
                  </h4>

                  <p className={`text-sm leading-relaxed text-slate-700`}>
                    {selectedDoctorAbout}
                  </p>

                  <a href={doctorInfo?.DOCLINK} target="_blank">
                    <button className="mt-4 flex items-center gap-1.5 group transition-all duration-200">
                      <span
                        style={{
                          color: "#0095da",
                          fontSize: "11px",
                          fontWeight: 600,
                          position: "relative",
                          right: "0px",
                          paddingTop: "0px",
                          top: "0px",
                        }}
                      >
                        View Full Profile
                      </span>
                      <FaChevronRight
                        style={{ color: "#0095da", fontSize: "8px" }}
                        className="group-hover:translate-x-0.5 transition-transform duration-200"
                      />
                    </button>
                  </a>

                  {/* {selectedDoctorAbout.length > 200 && (
                    <button
                      onClick={() => setShowMore(!showMore)}
                      className="mt-2 text-xs font-medium text-[#0095da] hover:underline"
                    >
                      {showMore ? "Show less" : "Show more"}
                    </button>
                  )} */}
                </div>
              )}
            </div>

            {/* RIGHT BOX — Appointment Form */}
            <div className="book-boxapp1">
              <h2>Please fill below details for appointment request</h2>

              <form className="space-y-6">
                {/* Registration Status */}
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-1">
                    <FiShield className="h-4 w-4 text-blue-600" />
                    Are you registered with us?
                  </label>
                  <div className="relative">
                    {/* Left user icon */}
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiUser className="h-5 w-5 text-gray-400" />
                    </div>

                    <select
                      className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition bg-white appearance-none cursor-pointer"
                      name="isRegistered"
                      value={formData.isRegistered}
                      onChange={handleChange}
                    >
                      <option value="No">No, I'm a new patient</option>
                      <option value="Yes">Yes, I'm registered</option>
                    </select>

                    {/* Right chevron arrow */}
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiChevronDown className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                </div>

                {/* Registered Patient Fields */}
                {showRegisteredFields && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* MRNO Search */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          MR Number
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                              />
                            </svg>
                          </div>
                          <input
                            type="text"
                            className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            name="mrNo"
                            value={formData.mrNo}
                            onChange={handleMRNOChange}
                            placeholder="Enter MR number"
                            disabled={isSearching}
                          />
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            {isSearching ? (
                              <div className="animate-spin h-5 w-5 border-2 border-blue-500 rounded-full border-t-transparent"></div>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-gray-400 hover:text-blue-500 cursor-pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                        {searchError && (
                          <p className="mt-1 text-sm text-red-600 flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 mr-1"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                            {searchError}
                          </p>
                        )}
                      </div>

                      {/* Mobile Search */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Mobile Number
                        </label>
                        <div className="relative" ref={dropdownRef}>
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-5 w-5 text-gray-400"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                              />
                            </svg>
                          </div>
                          <input
                            ref={inputRef}
                            type="text"
                            className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                            name="mobileNoSearch"
                            value={formData.mobileNoSearch}
                            onFocus={handleInputFocus}
                            onChange={handleMobileSearchChange}
                            placeholder="Enter mobile number"
                            autoComplete="off"
                          />
                          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                            {isSearching ? (
                              <div className="animate-spin h-5 w-5 border-2 border-blue-500 rounded-full border-t-transparent"></div>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 text-gray-400 hover:text-blue-500 cursor-pointer"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                />
                              </svg>
                            )}
                          </div>
                          {showDropdown && searchResults.length > 0 && (
                            <div
                              className="absolute  mt-1 w-full bg-white shadow-lg rounded-lg border border-gray-200 max-h-60 overflow-auto"
                              style={{ zIndex: "99" }}
                            >
                              <ul className="divide-y divide-gray-200">
                                {searchResults.map((patient) => (
                                  <li
                                    key={patient.REGNO}
                                    className="px-4 py-3 hover:bg-blue-50 cursor-pointer transition flex items-center"
                                    onClick={() =>
                                      handleSelectPatient(patient.REGNO)
                                    }
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-5 w-5 text-blue-500 mr-2"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                      />
                                    </svg>
                                    <div>
                                      <div className="font-medium text-gray-900">
                                        {patient.REGNO}
                                      </div>
                                      <div className="text-sm text-gray-500">
                                        {patient.MOBILE}
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        {searchError && (
                          <p className="mt-1 text-sm text-red-600 flex items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className="h-4 w-4 mr-1"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                              />
                            </svg>
                            {searchError}
                          </p>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {/* Patient Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Patient Name */}
                  <div>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiUser className="h-5 w-5 text-gray-400" />
                      </div>

                      <input
                        type="text"
                        className={`w-full pl-10 pr-4 py-3 border ${
                          errors.patientName
                            ? "border-red-500"
                            : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition`}
                        name="patientName"
                        value={formData.patientName}
                        onChange={handleChange}
                        placeholder="Patient full name*"
                      />
                    </div>
                    {errors.patientName && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.patientName}
                      </p>
                    )}
                  </div>

                  {/* Mobile Number */}
                  <div>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pointer-events-none z-10">
                        {/* India Flag + Country Code */}
                        <div className="flex items-center gap-1.5 pl-3 pr-3 border-r border-gray-300 h-full">
                          {/* India Flag SVG */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 900 600"
                            className="w-5 h-3.5 rounded-sm shadow-sm"
                          >
                            <rect width="900" height="600" fill="#FF9933" />
                            <rect
                              y="200"
                              width="900"
                              height="200"
                              fill="#FFFFFF"
                            />
                            <rect
                              y="400"
                              width="900"
                              height="200"
                              fill="#138808"
                            />
                            <circle
                              cx="450"
                              cy="300"
                              r="60"
                              fill="none"
                              stroke="#000080"
                              strokeWidth="8"
                            />
                            <circle cx="450" cy="300" r="8" fill="#000080" />
                            {[...Array(24)].map((_, i) => (
                              <line
                                key={i}
                                x1="450"
                                y1="248"
                                x2="450"
                                y2="258"
                                stroke="#000080"
                                strokeWidth="3"
                                transform={`rotate(${i * 15}, 450, 300)`}
                              />
                            ))}
                          </svg>
                          <span className="text-sm font-semibold text-gray-700 tracking-wide">
                            +91
                          </span>
                        </div>
                      </div>

                      <input
                        type="tel"
                        className={`w-full pl-24 pr-10 py-3 border ${
                          errors.mobileNumber
                            ? "border-red-500"
                            : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition bg-white`}
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        maxLength="10"
                        placeholder="Mobile number*"
                      />
                    </div>
                    {errors.mobileNumber && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.mobileNumber}
                      </p>
                    )}
                  </div>
                </div>

                {/* Email and Gender */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Email */}
                  <div>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiMail className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="email"
                        className={`w-full pl-10 pr-4 py-3 border ${
                          errors.email ? "border-red-500" : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition`}
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="Email address*"
                      />
                    </div>
                    {errors.email && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.email}
                      </p>
                    )}
                  </div>

                  {/* Gender */}
                  <div>
                    <div className="relative">
                      {/* Left icon */}
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiUsers className="h-5 w-5 text-gray-400" />
                      </div>

                      <select
                        className={`w-full pl-10 pr-10 py-3 border ${
                          errors.gender ? "border-red-500" : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition appearance-none bg-white cursor-pointer`}
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                      >
                        <option value="">Select gender*</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>

                      {/* Right chevron arrow */}
                      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiChevronDown className="h-5 w-5 text-gray-400" />
                      </div>
                    </div>

                    {errors.gender && (
                      <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                        <FiAlertCircle className="h-4 w-4" />
                        {errors.gender}
                      </p>
                    )}
                  </div>
                </div>

                {/* Age and Consultation Type */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Age */}
                  <div>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiCalendar className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="number"
                        className={`w-full pl-10 pr-4 py-3 border ${
                          errors.age ? "border-red-500" : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition`}
                        name="age"
                        value={formData.age}
                        onChange={handleChange}
                        placeholder="Age*"
                      />
                    </div>
                    {errors.age && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.age}
                      </p>
                    )}
                  </div>

                  <div>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                        <FiMapPin className="h-5 w-5 text-gray-400" />
                      </div>
                      <input
                        type="text"
                        className={`w-full pl-10 pr-4 py-3 border ${
                          errors.address ? "border-red-500" : "border-gray-300"
                        } rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition`}
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Enter address*"
                      />
                    </div>
                    {errors.address && (
                      <p className="mt-1 text-sm text-red-600 flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {errors.address}
                      </p>
                    )}
                  </div>
                </div>

                {/* Consultation Type */}
                <div>
                  <div className="relative">
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiMonitor className="h-5 w-5 text-gray-400" />
                    </div>
                    <select
                      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition appearance-none bg-white"
                      name="consultationType"
                      value={formData.consultationType}
                      onChange={handleChange}
                    >
                      <option value="">Select consultation type*</option>
                      <option value="In-Hospital">
                        In-Person Consultation
                      </option>
                      <option value="online-Tele-Consult">
                        Online Tele-Consultation
                      </option>
                    </select>
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiChevronDown className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    How did you hear about us?
                  </label>
                  <div className="relative">
                    {/* Left icon */}
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiGlobe className="h-5 w-5 text-gray-400" />
                    </div>

                    <select
                      className="w-full pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition appearance-none bg-white cursor-pointer"
                      name="sourceType"
                      value={formData.sourceType}
                      onChange={handleChange}
                    >
                      <option value="">Select source type</option>
                      <option value="JUSTDIAL">Just Dial</option>
                      <option value="REFERRAL-DOCTOR">Referral Doctor</option>
                      <option value="PROFESSIONAL">
                        Professional Leaflets
                      </option>
                      <option value="MAGAZINE">Magazine</option>
                      <option value="CAMPS">Camps</option>
                      <option value="REFERENCE">Reference</option>
                      <option value="MEDIA">Media</option>
                      <option value="OUTDOOR-HOARDINGS">
                        Outdoor Hoardings
                      </option>
                      <option value="PRINT">Print</option>
                      <option value="WEB-PORTAL">Web Portal</option>
                      <option value="FRIENDS-RELATIVES">
                        Friends / Relatives
                      </option>
                      <option value="DIGITALREFF">Digital Referral</option>
                      <option value="Practo">Practo</option>
                      <option value="Vaidam">Vaidam</option>
                      <option value="Other">Other</option>
                    </select>

                    {/* Right chevron arrow */}
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none z-10">
                      <FiChevronDown className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                </div>

                {!showRegisteredFields && formData?.RegFee && (
                  <div className="flex items-center justify-between px-4 py-3 rounded-lg border border-blue-200 bg-blue-50">
                    <div className="flex items-center gap-2">
                      <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100">
                        <FiCreditCard className="h-4 w-4 text-blue-600" />
                      </div>
                      <div>
                        <p className="text-xs text-blue-500 font-medium uppercase tracking-wide">
                          Registration Fee
                        </p>
                        <p className="text-sm text-blue-800 font-medium">
                          One-time patient registration charge
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-xl font-semibold text-[#0095da]">
                        ₹ {Number(formData.RegFee).toLocaleString("en-IN")}
                      </p>
                    </div>
                  </div>
                )}

                {/* Payment Summary and Submit */}
                <div className="pt-2">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={loading}
                    className={`w-full px-6 py-4 rounded-lg font-medium text-white ${
                      loading
                        ? "bg-blue-400"
                        : "bg-[#0095da] hover:bg-white hover:text-[#0095da] hover:border-[#0095da]"
                    } transition shadow-md hover:shadow-lg flex items-center justify-center border border-transparent`}
                  >
                    {loading ? (
                      <>
                        <FiLoader className="animate-spin mr-3 h-5 w-5" />
                        Processing your request...
                      </>
                    ) : (
                      <>
                        <FiCalendar className="h-5 w-5 mr-2" />
                        Confirm Appointment
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <OTPPopup
        show={showOTPPopup}
        onClose={() => {
          setShowOTPPopup(false);
        }}
        onVerify={handleVerifyOTP}
        sendOtp={sendOtp}
      />

      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          message={notification.message}
          type={notification.type}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </>
  );
};

export default AppoinmentBook;
